import React from 'react';
import ReactDOM from 'react-dom/client';
import { CustomDialog } from '../components/CustomDialog';

interface DialogOptions {
  title?: string;
  type?: 'info' | 'success' | 'error' | 'warning' | 'confirm';
  confirmText?: string;
  cancelText?: string;
}

class DialogService {
  private container: HTMLDivElement | null = null;
  private root: ReactDOM.Root | null = null;

  private ensureContainer() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'dialog-service-root';
      document.body.appendChild(this.container);
      this.root = ReactDOM.createRoot(this.container);
    }
  }

  private render(component: React.ReactElement) {
    this.ensureContainer();
    if (this.root) {
      this.root.render(component);
    }
  }

  private unmount() {
    if (this.root) {
      this.root.unmount();
    }
  }

  showAlert(message: string, options: DialogOptions = {}): Promise<void> {
    return new Promise((resolve) => {
      const handleClose = () => {
        this.unmount();
        resolve();
      };

      this.render(
        <CustomDialog
          isOpen={true}
          onClose={handleClose}
          message={message}
          title={options.title}
          type={options.type || 'info'}
          confirmText={options.confirmText || 'OK'}
          onConfirm={handleClose}
          showCancel={false}
        />
      );
    });
  }

  showConfirm(message: string, options: DialogOptions = {}): Promise<boolean> {
    return new Promise((resolve) => {
      const handleConfirm = () => {
        this.unmount();
        resolve(true);
      };

      const handleCancel = () => {
        this.unmount();
        resolve(false);
      };

      this.render(
        <CustomDialog
          isOpen={true}
          onClose={handleCancel}
          message={message}
          title={options.title}
          type={options.type || 'confirm'}
          confirmText={options.confirmText || 'Да'}
          cancelText={options.cancelText || 'Отмена'}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          showCancel={true}
        />
      );
    });
  }
}

export const dialogService = new DialogService();

// Глобальные обёртки для удобства
export const showAlert = (message: string, options?: DialogOptions) => 
  dialogService.showAlert(message, options);

export const showConfirm = (message: string, options?: DialogOptions) => 
  dialogService.showConfirm(message, options);

